import { css } from 'styled-components/macro';

export const hoverSupport = (...args) => css`
  @media (hover: hover) {
    &:hover {
      ${css(...args)}
    }
  }
`;
